import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "doc-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "doc-body" }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_progress_circular, {
                  "model-value": "20",
                  size: "56",
                  color: "primary",
                  indeterminate: ""
                })
              ]))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "doc-html",
                  innerHTML: _ctx.text
                }, null, 8, _hoisted_3))
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "flat",
            color: "primary",
            onClick: _ctx.onClose
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("ОК")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}